/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantConfig } from '../../models/tenant-config';
import { TenantConfigRequestDto } from '../../models/tenant-config-request-dto';

export interface AdminTenantPut$Params {
      body?: TenantConfigRequestDto
}

export function adminTenantPut(http: HttpClient, rootUrl: string, params?: AdminTenantPut$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<TenantConfig>> {
  const rb = new RequestBuilder(rootUrl, adminTenantPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<TenantConfig>;
    })
  );
}

adminTenantPut.PATH = '/Admin/tenant';
